import React from "react";
import { Card, Badge } from "react-bootstrap";
import { _t } from "../../../../app/i18n/i18n";

export const FilterHeader = ({ icon, filter, label, category, category_en, isOpen, toggleOpen }) => {
  const numFilters = filter[category] ? filter[category].length : null;
  const angleIcon = isOpen ? "fa-angle-up" : "fa-angle-down";

  return (
    <Card.Header
      onClick={toggleOpen}
      className={"border-1 my-0 p-2 clearfix cursor-pointer " + (numFilters ? "text-primary" : "text-dark")}
    >
      <i className={`fa ${icon} fa-lg fa-fw align-middle mr-3`} />
      {_t(label || category_en)}
      <span className={"float-right "}>
        <Badge pill variant="primary">
          {numFilters}
        </Badge>
        <i className={`fa ${angleIcon} fa-lg mx-2`} />
      </span>
    </Card.Header>
  );
};
